import { render, staticRenderFns } from "./CoCardPage.vue?vue&type=template&id=2806a416&"
import script from "./CoCardPage.vue?vue&type=script&lang=ts&"
export * from "./CoCardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports